import { Fragment, useRef, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, DialogContentText } from '@mui/material';
import useHttp from "../../../hooks/use-http";
import { getUpdatePassword } from "../../../lib/sts-api";
import { RegInput } from "../../UI/Styles/FormStyles";


const UpdatePasswordModal = ({onClose, autoUpdate}) => {
    const { sendRequest } = useHttp(getUpdatePassword, true);
    const [getNew, setNew] = useState('');
    const [getOld, setOld] = useState('');
    const [getPW2, setPW2] = useState('');

    const [isLoading, setIsLoading] = useState(false);

    const handleOld = (e) => {
        setOld(e.target.value);
    }

    const handleNew = (e) => {
        setNew(e.target.value);
    }

    const handleNew2 = (e) => {
        setPW2(e.target.value);
    }

    const handleUpdate = async (e) => {
        e.preventDefault();
        //setIsLoading(true);

        if (getOld !== getNew) {
            const info = {
                'old_password': getOld,
                'password': getNew,
                'password2': getPW2
            }

            try {
                const updated = await getUpdatePassword(info);
                if (updated.ok) {
                    alert('Password Updated Successfully');
                    onClose();
                } else {
                    alert(new Error(updated.message));
                }
                setIsLoading(false);
            } catch (error) {
                console.log(error)
            }
        } else {
            alert('Old Password Cannot be New Password');
        }
    }
    
    return (
        <Fragment>
            <Dialog open={true}>
                <div className="h-full w-full border-solid border-2 border-bg-white/40 shadow-2xl text-text-white rounded-lg bg-dark-grey/70 ">
                    <DialogTitle>Update Current Password</DialogTitle>
                    <DialogContent className="h-full w-full m-auto text-xs my-5 block" >
                        <form onSubmit={handleUpdate}>
                            <div className="w-max h-max mx-auto block">
                                <label htmlFor='old_password'>Old Password</label>
                                    <br />
                                <input
                                    type='password'
                                    className={RegInput} 
                                    required 
                                    placeholder="old password" 
                                    value={getOld}
                                    onChange={handleOld}
                                />
                            </div>

                            <div className="w-max h-max mx-auto block py-2">
                                <label htmlFor='new_password'>New Password</label>
                                    <br />
                                <input
                                    type='password'
                                    className={RegInput} 
                                    required 
                                    placeholder="new password" 
                                    value={getNew} 
                                    onChange={handleNew}
                                />
                            </div>

                            <div className="w-max h-max mx-auto block py-2">
                                <label htmlFor='new_password'>Confirm Password</label>
                                    <br />
                                <input
                                    type='password'
                                    className={RegInput} 
                                    required 
                                    placeholder="confirm password" 
                                    value={getPW2} 
                                    onChange={handleNew2}
                                />
                            </div>
                        </form>
                    </DialogContent>
                    <DialogActions>
                        {!autoUpdate && <Button onClick={onClose}>Close</Button>}

                        <Button onClick={handleUpdate} variant="contained" color="primary" disabled={isLoading}>
                            {isLoading ? 'Updating...' : 'Update'}
                        </Button>
                    </DialogActions>
                </div>
            </Dialog>
        </Fragment>
    );
}

export default UpdatePasswordModal;
